import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
interface CompletionContextValue {
  isDone: (id: string) => boolean;
  toggle: (id: string) => void;
  doneCount: number;
  clearAll: () => void;
}
const STORAGE_KEY = 'content-ops-completed';
const CompletionContext = createContext<CompletionContextValue | undefined>(undefined);
function readStored(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}
export function CompletionProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [done, setDone] = useState<Set<string>>(() => new Set(readStored()));
  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(done)));
  }, [done]);
  const toggle = useCallback((id: string) => {
    setDone(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else next.add(id);
      return next;
    });
  }, []);
  const clearAll = useCallback(() => setDone(new Set()), []);
  const value = useMemo<CompletionContextValue>(() => ({
    isDone: (id: string) => done.has(id),
    toggle,
    doneCount: done.size,
    clearAll
  }), [done, toggle, clearAll]);
  return <CompletionContext.Provider value={value} data-id="element-163" data-mp="12auigpw26wta">{children}</CompletionContext.Provider>;
}
export function useCompletion(): CompletionContextValue {
  const ctx = useContext(CompletionContext);
  if (!ctx) throw new Error('useCompletion must be used within a CompletionProvider');
  return ctx;
}